var map = {
	"./united-dark.png": 781,
	"./united.png": 782
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;


//////////////////
// WEBPACK FOOTER
// ./src/components/AirlineLogo/images/logos ^\.\/united.*\.png$
// module id = 780
// module chunks = 0